var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 171.02
  }), /*#__PURE__*/React.createElement("rect", {
    y: 340.98,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 171.02
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.5,
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 171
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M153.86,284.665l2.902,8.701l9.172,0.071c1.188,0.009,1.68,1.525,0.725,2.23l-7.379,5.449   l2.767,8.745c0.358,1.132-0.931,2.069-1.897,1.378l-7.462-5.334l-7.462,5.334c-0.966,0.691-2.255-0.246-1.897-1.378l2.767-8.745   l-7.379-5.449c-0.955-0.705-0.463-2.221,0.725-2.23l9.172-0.071l2.902-8.701C151.891,283.539,153.484,283.539,153.86,284.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M171.679,256.965l-1.555,9.04l8.05,4.398c1.042,0.569,0.76,2.138-0.415,2.308l-9.078,1.314   l-1.695,9.015c-0.219,1.167-1.798,1.383-2.323,0.318l-4.055-8.227l-9.097,1.173c-1.178,0.152-1.871-1.283-1.02-2.111l6.572-6.399   l-3.927-8.289c-0.508-1.073,0.642-2.176,1.693-1.623l8.117,4.273l6.67-6.297C170.476,255.042,171.88,255.795,171.679,256.965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M194.228,232.722l-4.305,8.1l6.27,6.695c0.812,0.867,0.053,2.268-1.117,2.062l-9.034-1.591   l-4.43,8.032c-0.574,1.04-2.141,0.751-2.306-0.425l-1.278-9.083l-9.008-1.731c-1.166-0.224-1.376-1.804-0.309-2.325l8.244-4.022   l-1.137-9.102c-0.147-1.178,1.29-1.866,2.115-1.012l6.373,6.597l8.305-3.894C193.687,230.519,194.785,231.673,194.228,232.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M221.365,217.68l-6.329,6.64l4.233,8.137c0.548,1.054-0.56,2.198-1.631,1.685l-8.27-3.967   l-6.431,6.541c-0.833,0.847-2.264,0.147-2.106-1.031l1.217-9.092l-8.208-4.095c-1.063-0.53-0.839-2.108,0.329-2.322l9.023-1.652   l1.358-9.072c0.176-1.174,1.745-1.449,2.31-0.404l4.359,8.071l9.047-1.512C221.438,215.413,222.184,216.821,221.365,217.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M252.555,210.711l-7.876,4.702l1.899,8.974c0.246,1.162-1.129,1.968-2.023,1.186l-6.905-6.038   l-7.948,4.579c-1.029,0.593-2.22-0.465-1.753-1.557l3.608-8.433l-6.811-6.144c-0.882-0.795-0.244-2.256,0.939-2.149l9.135,0.826   l3.739-8.376c0.484-1.084,2.07-0.929,2.334,0.229l2.038,8.943l9.122,0.967C253.233,208.546,253.575,210.102,252.555,210.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M358.14,284.665l-2.902,8.701l-9.172,0.071c-1.188,0.009-1.68,1.525-0.725,2.23l7.379,5.449   l-2.767,8.745c-0.358,1.132,0.931,2.069,1.897,1.378l7.462-5.334l7.462,5.334c0.966,0.691,2.255-0.246,1.897-1.378l-2.767-8.745   l7.379-5.449c0.955-0.705,0.463-2.221-0.725-2.23l-9.172-0.071l-2.902-8.701C360.109,283.539,358.516,283.539,358.14,284.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M340.321,256.965l1.555,9.04l-8.05,4.398c-1.042,0.569-0.76,2.138,0.415,2.308l9.078,1.314   l1.695,9.015c0.219,1.167,1.798,1.383,2.323,0.318l4.055-8.227l9.097,1.173c1.178,0.152,1.871-1.283,1.02-2.111l-6.572-6.399   l3.927-8.289c0.508-1.073-0.642-2.176-1.693-1.623l-8.117,4.273l-6.67-6.297C341.524,255.042,340.12,255.795,340.321,256.965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M317.772,232.722l4.305,8.1l-6.27,6.695c-0.812,0.867-0.053,2.268,1.117,2.062l9.034-1.591   l4.43,8.032c0.574,1.04,2.141,0.751,2.306-0.425l1.278-9.083l9.008-1.731c1.166-0.224,1.376-1.804,0.309-2.325l-8.244-4.022   l1.137-9.102c0.147-1.178-1.29-1.866-2.115-1.012l-6.373,6.597l-8.305-3.894C318.313,230.519,317.215,231.673,317.772,232.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M290.635,217.68l6.329,6.64l-4.233,8.137c-0.548,1.054,0.56,2.198,1.631,1.685l8.27-3.967   l6.431,6.541c0.833,0.847,2.264,0.147,2.106-1.031l-1.217-9.092l8.208-4.095c1.063-0.53,0.839-2.108-0.329-2.322l-9.023-1.652   l-1.358-9.072c-0.176-1.174-1.745-1.449-2.31-0.404l-4.359,8.071l-9.047-1.512C290.562,215.413,289.816,216.821,290.635,217.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M259.445,210.711l7.876,4.702l-1.899,8.974c-0.246,1.162,1.129,1.968,2.023,1.186l6.905-6.038   l7.948,4.579c1.029,0.593,2.22-0.465,1.753-1.557l-3.608-8.433l6.811-6.144c0.882-0.795,0.244-2.256-0.939-2.149l-9.135,0.826   l-3.739-8.376c-0.484-1.084-2.07-0.929-2.334,0.229l-2.038,8.943l-9.121,0.967C258.767,208.546,258.425,210.102,259.445,210.711z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVe);
export default __webpack_public_path__ + "static/media/ve.100a8ca169b0f87588142746edebb2cd.svg";
export { ForwardRef as ReactComponent };